<ng-template #addProductModal let-c="close" let-d="dismiss">
  <form #addProductForm="ngForm" [class.submitted]="addProductForm.submitted"
        (ngSubmit)="processRecord(addProductForm)" novalidate>
    <div class="modal-header">
      <h4 class="modal-title">{{(isEdit ? "GENERICS.EDIT" : "GENERICS.ADD") | translate}} {{"PRODUCTS.PRODUCT" | translate}}</h4>
      <button type="button" class="btn btn-close" aria-label="Close" (click)="d()"></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-8">
          <div class="form-group">
            <label for="name" class="text-uppercase">{{"PRODUCTS.PRIMARY_NAME" | translate}}:
              <rms-required-label [componentForm]="addProductForm" [formFieldReference]="nameRef"></rms-required-label>
            </label>
            <input id="name" name="name" [(ngModel)]="product.name" #nameRef="ngModel" class="form-control" required>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="companyIds">
              {{"COMPANY.COMPANIES" | translate}}
              <rms-required-label [componentForm]="addProductForm" [formFieldReference]="companyIdsRef"></rms-required-label>
            </label>
            <ng-select [items]="companyList?.records"
                       bindLabel="name"
                       bindValue="id"
                       [multiple]="true"
                       [hideSelected]="true"
                       [typeahead]="companiesTypeahead"
                       name="companyIds"
                       id="companyIds"
                       #companyIdsRef="ngModel"
                       required
                       [(ngModel)]="product.companyIds">
            </ng-select>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="synonyms">{{"GENERICS.SYNONYMS" | translate}} ({{"GENERICS.SEPARATE_BY_COMMAS" | translate}})</label>
            <ng-select [items]="synonymsList"
                       bindLabel="text"
                       [multiple]="true"
                       [hideSelected]="true"
                       [addTag]="true"
                       name="synonyms"
                       id="synonyms"
                       #synonymsRef="ngModel"
                       [(ngModel)]="product.synonyms">
            </ng-select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="c()">{{"GENERICS.CANCEL" | translate}}</button>
      <button type="submit" class="btn btn-primary">{{"GENERICS.SAVE" | translate}}</button>
    </div>
  </form>
</ng-template>
